import React from "react";
import styles from "./index.module.scss";
import ButtonC from "../../common/button";
import Input from "../../common/input";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useInvestorLogin } from "../../../hooks/react-query/investor/useInvestorLogin";
import useContextHook from "../../../hooks/context/useContext";
import { LoginWithOTP } from "../amplitude";
import { Dialog } from "primereact/dialog";

export default function InvestorLoginC() {
  const [error, setError] = React.useState("");
  const [visible, setVisible] = React.useState(false);
  const navigate = useNavigate();
  const { mobileNumber, setMobileNumber } = useContextHook();
  const [searchParams] = useSearchParams();
  const continueParam: any = searchParams.get("continue");
  const continueUrl = new URL(continueParam, window.location.origin);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;

    if (/^\d*$/.test(inputValue)) {
      setMobileNumber(inputValue);
      if (error) setError("");
    }
  };

  const loginMutation = useInvestorLogin(
    (data: any) => {
      // No sfid here any more — send-otp returns a uniform response that reveals nothing
      // about whether this number belongs to an investor. It is set after verify-otp.
      LoginWithOTP({
        mobileNumber: mobileNumber,
        linkCId: continueUrl.searchParams.get("cid") || "",
        linkEmailId: continueUrl.searchParams.get("eq") || ""
      });
      if (continueParam) {
        // Preserve all query parameters from the continue URL

        const otpRedirectUrl = `/investor-otp-verification?continue=${encodeURIComponent(
          continueParam
        )}`;
        navigate(otpRedirectUrl);
      } else {
        navigate("/investor-otp-verification");
      }
    },
    (error) => {
      // Never surface the server's message verbatim. This line used to print "Contact not
      // found." straight onto the page, which turned the login screen itself into a tool for
      // discovering who your investors are. The backend is uniform now; this keeps the UI
      // from reintroducing the leak if an error path is ever added back.
      setError("Something went wrong. Please try again.");
    }
  );

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (mobileNumber.length === 0) {
      setError("Please enter mobile number");
      return;
    }
    if (mobileNumber.length !== 10) {
      setError("Please enter valid mobile number");
      return;
    }
    localStorage.setItem("mobileNumber", mobileNumber);
    loginMutation.mutate({ mobile: mobileNumber });
  };

  return (
    <>
      <Dialog
        dismissableMask={true}
        header=""
        visible={visible}
        className={styles.dialog}
        onHide={() => setVisible(false)}
        draggable={false}
        resizable={false}
      >
        Hmmm.... Something's missing! We couldn’t find your phone number in our
        system to send you an OTP. 🤔 But no worries! If you think this is a
        mistake, just give us a shout at{" "}
        <Link to="mailto:it@ftreca.com">support@ftreca.com</Link>, and we’ll
        sort it out in no time! 💌😊
      </Dialog>

      <div className={styles.loginBox}>
        <div className={styles.heading}>
          <img src="/images/logo.svg" alt="" className={styles.logo} />
          <div className={styles.title}>Clarity</div>
        </div>
        <div className={styles.InputWrap}>
          <Input
            maxLength={15}
            type="text"
            onChange={handleInputChange}
            placeholder="Enter Your Mobile Number"
            label="Enter Your Mobile Number"
            value={mobileNumber}
            onKeyDown={(e: any) => {
              if (e.key === "Enter") handleSubmit(e);
            }}
            name="Mobile Number"
            touched={!!error}
            onBlur={() => {
              if (!mobileNumber) {
                setError("Please enter a mobile number.");
              }
            }}
            className={styles.amountInput}
            tabIndex={1}
            isError={!!error}
            autoFocus={true}
            errorMessage={error}
          />
          <ButtonC
            type="button"
            loading={loginMutation.isPending}
            className={styles.SalesforceBtn}
            label="Login with OTP"
            bgColor={"blueBg"}
            tabIndex={1}
            onClick={handleSubmit}
          />
        </div>
      </div>
    </>
  );
}
